// @flow
import React, { PureComponent } from 'react';
import type { Node } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Icon from 'Common/Icon';
import styles from 'components/BreadCrumb.scss';
import { changeMake, changeModel } from 'Common/makeAndModelFormatting';

import { toCapitalize } from 'Common/string';
import { gtmEventPush } from 'utils/gtm/events';

/**
 * <BreadCrumb /> component.
 */
class BreadCrumb extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   */
  static propTypes = {
    breadCrumbUrl: PropTypes.string
  };

  /**
   * Renders <Image /> component.
   *
   * @return {JSX} - renders a logo.
   */
  render(): Node {
    const { breadCrumbUrl } = this.props;

    let breadCrumbsItems = breadCrumbUrl.split('/');

    // Remove Id elements path (numerical ids or 8 character hash)
    breadCrumbsItems = breadCrumbsItems
      .filter(item => {
        return !/(^\d+$|-[a-f0-9]{8}$)/.test(item);
      })
      .map((_, i) => {
        if (i === 1) {
          return toCapitalize(_.replace(/-/g, ' '));
        } else if (i === 2) {
          return changeMake(_);
        } else if (i === 3 || i === 4) {
          return changeModel(_.replace(/-/g, ' '));
        }

        return _;
      });

    return (
      <ul
        className={styles.breadCrumb}
        vocab="http://schema.org/"
        typeof="BreadcrumbList"
      >
        {breadCrumbsItems.map((item, key) => {
          if (item) {
            const displayText = item.replace(/-/g, ' ');
            return (
              <li key={key} property="itemListElement" typeof="ListItem">
                {key > 1 && (
                  <Icon
                    iconName={'angle-left'}
                    size={'small'}
                    className={styles.icon}
                  />
                )}
                {key < breadCrumbsItems.length - 1 && (
                  <Link
                    onClick={() =>
                      gtmEventPush({
                        method: 'breadcrumb',
                        args: {
                          displayText
                        }
                      })
                    }
                    property="item"
                    typeof="WebPage"
                    to={breadCrumbsItems
                      .slice(0, key + 1)
                      .join('/')
                      .replace(/ /g, '-')
                      .toLowerCase()}
                  >
                    <span property="name">{displayText}</span>
                  </Link>
                )}
                {key === breadCrumbsItems.length - 1 && item}
                <meta property="position" content={key} />
              </li>
            );
          }
        })}
      </ul>
    );
  }
}

export default BreadCrumb;



// WEBPACK FOOTER //
// ./src/Common/BreadCrumb/index.js